import { render, staticRenderFns } from "./education_info.vue?vue&type=template&id=1c32970f&scoped=true"
import script from "./education_info.vue?vue&type=script&lang=js"
export * from "./education_info.vue?vue&type=script&lang=js"
import style0 from "./education_info.vue?vue&type=style&index=0&id=1c32970f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c32970f",
  null
  
)

export default component.exports